
/**
 * APP 外打开的网页通用模版，顶部显示 app应用商店banner，底部显示 【APP内打开】按钮
 */
import { mapState } from 'vuex'
import { setRem } from '~/utils/mobile'
import { openApp } from '@Common'
export default {
    computed: {
        ...mapState({
            isInApp: state => state.mobile.isInApp,
            openInAppData: state => state.mobile.openInAppData,
            fullLoadingData: state => state.mobile.fullLoadingData,
            msgBoxData: state => state.mobile.msgBoxData,
            toastData: state => state.mobile.toastData,
            confirmData: state => state.mobile.confirmData,
        })
    },
    data () {
        return {
            opacity: 0,
        }
    },
    mounted () {
        setRem(document, window)
        this.opacity = 1 // 解决网页加载闪烁问题
    },
}
